import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { DayClosePage } from '@/components/admin/dayclose/DayClosePage'
import type { User as UserType } from '@/types'
import { LoadingSpinner } from '@/components/ui/loading-spinner'

function DayCloseRoute() {
  const [user, setUser] = useState<UserType | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    try {
      const raw = localStorage.getItem('pos_user')
      if (raw) setUser(JSON.parse(raw) as UserType)
    } catch {
      // ignore — user will be redirected to login below
    }
    setLoading(false)
  }, [])

  if (loading) {
    return <LoadingSpinner text="Loading Daily Closing…" />
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Manager + admin can run the close. Other roles bounce out — the
  // sidebar already hides the entry point but we double-check on the
  // route in case someone deep-links.
  if (user.role !== 'admin' && user.role !== 'manager') {
    return <Navigate to="/admin" replace />
  }

  return <DayClosePage />
}

export const Route = createFileRoute('/admin/day-close')({
  component: DayCloseRoute,
})
